"use strict";

var IAdapter = require("./IAdapter");
var ILogger = require("./ILogger");
var IProcessor = require("./IProcessor");
exports = module.exports = {
  IAdapter: IAdapter,
  ILogger: ILogger,
  IProcessor: IProcessor
};